module.exports = __webpack_public_path__ + "static/assets/weui_location-outlined.svg";